import { CookieAttributes } from 'js-cookie';
import Result, { EmptyResult } from '../Result';

export class Record {
  public constructor(
    public readonly key: string,
    public readonly value: string,
    public readonly options?: CookieAttributes,
    public readonly permanent?: boolean,
  ) {}
}

export interface Storage {
  put(record: Record): Promise<Result>;
  remove(record: { key: string; options?: CookieAttributes }): Promise<EmptyResult>;
  get(key: string): Promise<Result<string | null | undefined>>;
  getName(): string;
}

export interface CookieStorage extends Storage {
  putMultiple(records: Record[]): Promise<Result>;
}
